module.exports = __webpack_public_path__ + "static/img/3.30e05ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/cooperation/3.png
// module id = c1uR
// module chunks = 3